//
// Row
//
// To center children horizontally, apply the classname 'mx-auto' to them.
//
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Row = function Row(props) {
  const {
    className,
    style: propStyle,
    gap = 2,
    fullw,
    absolute,
    start,
    end,
    between,
    around,
    evenly,
    baseline,
    crossStart,
    crossEnd,
    crossStretch,
    framed,
    onClick,
    id,
    children = null,
  } = props;

  // Copy, never write into the caller's object: React freezes a style object
  // once it has been committed, and it is never ours to change anyway
  const style = (gap)
    ? { ...propStyle, gap: `${gap / 4}rem` }
    : propStyle;

  const finalClassName = classNames(
    'flex flex-row',
    {
      'w-full': fullw,
      // Horizontal / main axis alignment:
      'justify-center': !(start || end || between || around || evenly),
      'justify-start': start,
      'justify-end': end,
      'justify-between': between,
      'justify-around': around,
      'justify-evenly': evenly,
      // Vertical / cross axis alignment:
      'items-center': !(baseline || crossStart || crossStretch || crossEnd),
      'items-baseline': baseline,
      'items-start': crossStart,
      'items-end': crossEnd,
      'items-stretch': crossStretch,
      'border border-pxOutlineStrong rounded-md': framed,
      'pointer-events-none': (onClick === false),
      'relative': !absolute,
      absolute,
    },
    className,
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={finalClassName}
        style={style}
        onClick={onClick}
        id={id}
      >
        {children}
      </button>
    );
  }

  return (
    <div
      className={finalClassName}
      style={style}
      id={id}
    >
      {children}
    </div>
  );
};

Row.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  gap: PropTypes.number,
  fullw: PropTypes.bool,
  absolute: PropTypes.bool,
  framed: PropTypes.bool,
  // Alignment along main axis:
  start: PropTypes.bool,
  end: PropTypes.bool,
  between: PropTypes.bool,
  around: PropTypes.bool,
  evenly: PropTypes.bool,
  // Alignment across main axis:
  baseline: PropTypes.bool,
  crossStart: PropTypes.bool,
  crossEnd: PropTypes.bool,
  crossStretch: PropTypes.bool,
  onClick: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  id: PropTypes.string,
  children: PropTypes.node,
};

export default Row;
